import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchCurrentUser, updateCurrentUser} from '../../../../creators/currentUser';
import {fetchUserQuestions} from "../../../../creators/user.questions";
import {createUserQuestion, deleteUserQuestion} from "../../../../creators/user.question";
import {fetchCurrentUserQuestions} from "../../../../creators/currentUser.questions";

import Icon from '../../../components/Icon';
import RequestQuestionsBlockSuggestions from './RequestQuestionsBlockSuggestions';
import {Button} from "../../../components/Button";
import Title from "../../../components/Title";
import {PageLoader} from "../../../components/Loader";
import {CheckboxInputField} from "../../../components/FormField";
import {config} from "../../../../config";
import Helmet from "react-helmet";

class AcquaintanceSettings extends React.Component {
    constructor(props) {
        super(props);
        this.groupList = [
            {group: 'general', label: ` "d'ordre général"`},
            {group: 'facondetre', label: ` "la façon d'être"`},
            {group: 'vousetmoi', label: ` dans le thème "vous et moi"`},
            {group: 'couple', label: ` "pour les couples"`},
            {group: 'femme', label: ` "pour les femmes"`},
            {group: 'homme', label: ` "pour les hommes"`},
        ];
        this.state = {
            isValidQuestion: {
                general: [],
                facondetre: [],
                vousetmoi: [],
                couple: [],
                femme: [],
                homme: []
            },
            displayFriends: true,
            friendRequestQuestions: false,
        };
        this.handleMessage = this.handleMessage.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleAddQuestion = this.handleAddQuestion.bind(this);
        this.handleDeleteQuestion = this.handleDeleteQuestion.bind(this);
        this.handleSettings = this.handleSettings.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        // this.props.fetchCurrentUser();
        this.props.fetchUserQuestions({limit: false});
        this.props.fetchCurrentUserQuestions();
    }

    componentDidMount(oldProps) {
        const newProps = this.props;
        if ((oldProps && oldProps.currentUserInitialized !== newProps.currentUserInitialized) || newProps.currentUserInitialized === true) {
            let currentUser = newProps.currentUser;
            this.setState({
                displayFriends: currentUser.setting.displayFriends,
                friendRequestQuestions: currentUser.setting.friendRequestQuestions,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.myQuestions !== this.props.myQuestions) {
            // console.log(this.props.myQuestions);
            this.setState({isValidQuestion: this.props.myQuestions});
        }
    }

    handleMessage(event, key) {
        let questions = this.state.questionValue;
        this.setState({questionValue: {...questions, [key]: {content: event.target.value}}});
    }

    handleCheck(value, key) {
        let questions = this.state.isValidQuestion;
        let currentQuestion = questions[key];
        let isPresent = currentQuestion && currentQuestion.filter(item => value._id === item._id);

        if (!isPresent.length) {
            currentQuestion.push(value);
        } else {
            currentQuestion = currentQuestion && currentQuestion.filter(item => value._id !== item._id);
        }
        this.setState({isValidQuestion: {...questions, [key]: currentQuestion}});
    }

    handleAddQuestion(group, content) {
        this.props.createUserQuestion({group, content})
    }

    handleDeleteQuestion(id){
        this.props.deleteUserQuestion(id);
    }

    handleSettings(name, value) {
        this.setState({[name]: value});
    }

    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        let question = {
            general: this.state.isValidQuestion.general.map(item => item._id),
            facondetre: this.state.isValidQuestion.facondetre.map(item => item._id),
            vousetmoi: this.state.isValidQuestion.vousetmoi.map(item => item._id),
            couple: this.state.isValidQuestion.couple.map(item => item._id),
            femme: this.state.isValidQuestion.femme.map(item => item._id),
            homme: this.state.isValidQuestion.homme.map(item => item._id)
        };
        // let currentUser = {
        //     setting: {
        //         displayFriends: this.state.displayFriends,
        //         friendRequestQuestions: this.state.friendRequestQuestions
        //     }
        // };

        if (!this.props.currentUserLoading) {
            let currentUser = {
                question,
                setting : {
                    displayFriends: this.state.displayFriends,
                    friendRequestQuestions: this.state.friendRequestQuestions,
                }
            };
            this.props.updateCurrentUser(currentUser);
        }
    }

    render() {
        return !this.props.currentUserInitialized ? <PageLoader/> : (
            <form onSubmit={(e) => this.handleSubmit(e)} id="acquaintance">
                <Helmet>
                    <title>{config.preTitle}Amis et demandes{config.postTitle}</title>
                </Helmet>
                <Title className={"settings-title"} heading={"heading-2"} display={"display-2"}>Amis et Demandes</Title>
                <div className="block">
                    <div className="settings-sub-title">Amis</div>
                    <CheckboxInputField checked={this.state.displayFriends}
                                        onChange={() => this.handleSettings('displayFriends', !this.state.displayFriends)}
                                        htmlFor="friendDisplay"
                                        id="friendDisplay"
                                        className={"my-8"}
                                        label={"Afficher mes amis dans mon profil"}/>
                    <CheckboxInputField checked={this.state.friendRequestQuestions}
                                        onChange={() => this.handleSettings('friendRequestQuestions', !this.state.friendRequestQuestions)}
                                        htmlFor="activateQuestions"
                                        id="activateQuestions"
                                        className={"my-8"}
                                        label={"Activer les questions pour faire connaissance"}/>
                </div>
                <div className="block mt-16">
                    <div className="settings-sub-title">Demandes</div>
                    <div className="topline">
                        Les questions que vous configurerez seront posées aléatoirement aux Voissanautes qui vous feront
                        une demande d'amitié. Vous pouvez ainsi créer un filtre suplémentaire et
                        en savoir plus sur eux avant d'accepter ou refuser leur demande.
                    </div>
                    <div className="acquaintance-form">
                        {this.groupList.map((item, index) => (
                            <RequestQuestionsBlockSuggestions
                                key={index}
                                list={this.props.questionsTotal >= 1 ? this.props.questions : []}
                                questionsLoading={this.props.questionsLoading}
                                group={item.group}
                                listCheckboxCheck={this.state.isValidQuestion}
                                title={`Suggestions de questions ${item.label}`}
                                handleCheck={this.handleCheck}
                                handleAddQuestion={this.handleAddQuestion}
                                handleDeleteQuestion={this.handleDeleteQuestion}
                            />
                        ))}
                    </div>
                    <div className="summary">
                        <h3>Vos questions</h3>
                        {this.groupList.map((itemGroup, indexGroup) => (
                            <div className="row" key={indexGroup}>
                                <span className="title">{`Questions ${itemGroup.label}`}</span>
                                {this.state.isValidQuestion[itemGroup.group].length >= 1 ? (
                                    <div className="questions">
                                        {this.state.isValidQuestion[itemGroup.group].map((item, index) => (
                                            <span className="added-question" key={index}>{item.content}
                                                <Icon type="close"
                                                      callback={() => this.handleCheck(item, itemGroup.group)}/>
                                        </span>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="questions">
                                        <span className="small-italic">Aucune question choisie sur ce thème</span>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="settings-btn-group">
                    <Button size={"medium"}
                            btnType={"submit"}
                            loading={this.props.currentUserSubmitting}
                            btnStyle={"primary-reverse"}
                            content={"Enregistrer"}/>
                </div>
            </form>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserSubmitting: state.currentUser.submitting,
        currentUserInitialized: state.currentUser.initialized,

        questions: state.userQuestions.data,
        questionsLoading: state.userQuestions.loading,
        questionsTotal: state.userQuestions.total,

        myQuestions: state.currentUserQuestions.data,
    }
};


const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    updateCurrentUser,
    fetchCurrentUserQuestions,
    fetchUserQuestions,
    createUserQuestion,
    deleteUserQuestion
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AcquaintanceSettings);
